var _xitiTrackerLoaded = false;

/**
* An object to manage Xiti Analytics as a TrackerManager plugin
* @constructs XitiTracker
* @memberof Class
* @author Alessandro Cipolletti
*/
function XitiTracker(serverConfNode) {
	var _self = this;
	
	_self.trackerUrl = serverConfNode.url;
	_self.loadTracker();
}

XitiTracker.prototype.isLoaded = function () {
	return _xitiTrackerLoaded;
}

/**
* Load the analytics tracker
* @author Alessandro Cipolletti
*/
XitiTracker.prototype.loadTracker = function () {
	var _self = this;
	
	if (_xitiTrackerLoaded) {
		_self.tag = new ATInternet.Tracker.Tag();
		return;
	}
	
	// Inclusion du script Xiti
	var script = document.createElement("script");
	script.setAttribute("type", "text/javascript");
	script.onload = function () {
		_self.tag = new ATInternet.Tracker.Tag();
		_xitiTrackerLoaded = true;
	};
	script.src = this.trackerUrl;
	document.head.appendChild(script);
	

};

/**
* Track a page view
* @param  {String} page  The page code name viewed
* @param  {String} hash  The hash of the page viewed
* @param  {String} title The page title
* @author Alessandro Cipolletti
*/
XitiTracker.prototype.trackPage = function (page, url, title) {
	this.tag.page.send({
		name: page,
		customObject: {
			page: page,
			url: url,
			title: title
		}
	});
};

/**
* Track a page event
* @param  {String}  category The event category
* @param  {String}  action   The event name
* @param  {String}  label    The action label
* @param  {integer} value    A complementary figure
* @author Alessandro Cipolletti
*/
XitiTracker.prototype.trackEvent = function (category, action, label, value) {
	this.tag.click.send({
		type: category,
		customObject: {
			category: category,
			action: action,
			label: label,
			value: value
		}
	});
};

module.exports = XitiTracker;



//////////////////
// WEBPACK FOOTER
// ./src/utils/statistics/trackers/xitiTracker.js
// module id = 794
// module chunks = 0